import { render, staticRenderFns } from "./ShopsTable.vue?vue&type=template&id=27381630&scoped=true"
import script from "./ShopsTable.vue?vue&type=script&lang=js"
export * from "./ShopsTable.vue?vue&type=script&lang=js"
import style0 from "./ShopsTable.vue?vue&type=style&index=0&id=27381630&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27381630",
  null
  
)

export default component.exports